var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('h3',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))]),_c('a-button',{staticClass:"el_button el-button--primary",attrs:{"type":"primary","size":"large"},on:{"click":_vm.GoAdd}},[_vm._v(" 新增客源 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }